import formatPrice from "../../../components/formatPrice";
import datetimeParser from "../../../components/datetimeParser";
import DownloadXML from "./DownloadXML";

const columns = [
	{
		title: "ID grupy",
		dataIndex: "msr_przekazania_generated_groups_own_id",
		width: "150px",
		key: "msr_przekazania_generated_groups_own_id",
		render: (item) => <div>#{item}</div>,
	},
	{
		title: "Liczba przekazów",
		dataIndex: "msr_przekazania_generated_groups_transfers",
		width: "170px",
		key: "msr_przekazania_generated_groups_transfers",
		render: (item, record) => (
			<div
				style={{
					fontSize: "14px",
					fontWeight: 600,
					textAlign: "right",
				}}
			>
				{record.przekazy ? record.przekazy.length : 0}
			</div>
		),
	},
	{
		title: "Kwota przekazów",
		dataIndex: "msr_przekazania_amount",
		key: "msr_przekazania_amount",
		width: "200px",
		render: (item, record) => (
			<div
				style={{
					fontSize: "14px",
					fontWeight: 700,
					textAlign: "right",
				}}
			>
				{formatPrice(
					(record.przekazy || []).reduce(
						(sum, p) =>
							sum + parseFloat(p.msr_przekazania_amount || 0),
						0,
					),
				)}{" "}
				zł
			</div>
		),
	},
	{
		title: "Wygenerowane przez",
		dataIndex: "msr_przekazania_generated_groups_agentid",
		key: "msr_przekazania_generated_groups_agentid",
		render: (item, record) => (
			<div style={{ fontSize: "14px", fontWeight: 600 }}>
				{record.userDetails?.mlg_users_fullname || "Brak danych"}
			</div>
		),
	},
	{
		title: "Data wygenerowania",
		dataIndex: "msr_przekazania_generated_groups_created_datetime",
		key: "msr_przekazania_generated_groups_created_datetime",
		render: (item) => (
			<div style={{ fontSize: "14px", fontWeight: 500 }}>
				{datetimeParser(item, "YYYY-MM-DD HH:mm:ss")}
			</div>
		),
	},
	{
		title: "Pobierz XML",
		dataIndex: "msr_przekazania_generated_files_name",
		key: "msr_przekazania_generated_files_name",
		render: (item, record) =>
			record.msr_przekazania_generated_files_id && (
				<DownloadXML
					fileName={record.msr_przekazania_generated_files_name}
					generatedFileId={record.msr_przekazania_generated_files_id}
					generatedGroupId={
						record.msr_przekazania_generated_groups_id
					}
					isGroup
				/>
			),
	},
];

export default columns;
